import { APIConfig } from "types";
import APIBase from "./apiBase";

export default class API extends APIBase {
    constructor(config?: APIConfig, logger?: (arg: string) => void) {
        if (!config) {
            config = {
                apiUrl: ''
            }
        }

        super(config, logger);
    }

    public async getMetadata(uri): Promise<any> {
        const result = this.get(uri);
        return result;
    }


}